// Icon: mdi-message-alert
// Slug: Adds custom validity to an element.
// Description: Allows you to add custom validity to an element using an expression.

import { attribute } from '@engine'
import { effect } from '@engine/signals'

attribute({
  name: 'custom-validity',
  requirement: {
    key: 'denied',
    value: 'must',
  },
  returnsValue: true,
  apply({ el, rx, error }) {
    if (
      !(
        el instanceof HTMLInputElement ||
        el instanceof HTMLSelectElement ||
        el instanceof HTMLTextAreaElement
      )
    ) {
      throw error('CustomValidityInvalidElement', {
        element: { tag: el.tagName },
      })
    }
    return effect(() => {
      const result = rx() as string
      if (typeof result !== 'string') {
        throw error('CustomValidityInvalidExpression', {
          expression: { value: result },
        })
      }
      el.setCustomValidity(result)
    })
  },
})
